import { useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/apiClient";
import { BRAND } from "@/constants/brand";

export default function Contact() {
  const [done, setDone] = useState(false);
  const [form, setForm] = useState({ name: "", email: "", phone: "", subject: "General Inquiry", message: "" });
  const submit = async (e) => {
    e.preventDefault();
    try { await api.post("/contact", form); setDone(true); toast.success("Message received."); }
    catch (err) { toast.error(formatApiError(err)); }
  };

  return (
    <div data-testid="contact-page" className="section-pad">
      <div className="container-pp grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <div className="text-[11px] uppercase tracking-[0.22em] text-brand-charcoal/55">Contact</div>
          <h1 className="editorial-h1 text-5xl md:text-6xl mt-3">Say hi. We answer fast.</h1>
          <p className="mt-6 text-brand-charcoal/70 leading-relaxed">WhatsApp is fastest. Email works. Forms work. Walk-ins are warmly accepted.</p>
          <div className="mt-8 space-y-5">
            <div className="card-soft p-6">
              <div className="text-[11px] uppercase tracking-[0.22em] text-brand-red">{BRAND.addresses.manufacturing.label}</div>
              <div className="font-display text-xl mt-1">{BRAND.addresses.manufacturing.line1}</div>
              <div className="text-sm text-brand-charcoal/70 mt-2">{BRAND.addresses.manufacturing.lines.join(", ")}</div>
            </div>
            <div className="card-soft p-6">
              <div className="text-[11px] uppercase tracking-[0.22em] text-brand-red">{BRAND.addresses.retail.label}</div>
              <div className="font-display text-xl mt-1">{BRAND.addresses.retail.line1}</div>
              <div className="text-sm text-brand-charcoal/70 mt-2">{BRAND.addresses.retail.lines.join(", ")}</div>
            </div>
            <a href={BRAND.whatsappUrl} target="_blank" rel="noreferrer" className="btn-pill btn-primary text-sm" data-testid="contact-wa">WhatsApp: +91 8867566028</a>
          </div>
        </div>
        <div className="lg:col-span-7">
          {done ? (
            <div className="card-elevated p-10" data-testid="contact-done">
              <h2 className="editorial-h1 text-4xl">Thank you, {form.name}.</h2>
              <p className="mt-4 text-brand-charcoal/70">We'll reply within 24 hours.</p>
            </div>
          ) : (
            <form className="card-elevated p-8 space-y-5" onSubmit={submit} data-testid="contact-form">
              <div className="grid sm:grid-cols-2 gap-5">
                <div><label className="text-[11px] uppercase tracking-[0.22em] text-brand-charcoal/55">Name</label><input data-testid="ct-name" className="pp-input" required value={form.name} onChange={(e)=>setForm({...form, name:e.target.value})} /></div>
                <div><label className="text-[11px] uppercase tracking-[0.22em] text-brand-charcoal/55">Email</label><input type="email" data-testid="ct-email" className="pp-input" required value={form.email} onChange={(e)=>setForm({...form, email:e.target.value})} /></div>
                <div><label className="text-[11px] uppercase tracking-[0.22em] text-brand-charcoal/55">Phone</label><input data-testid="ct-phone" className="pp-input" value={form.phone} onChange={(e)=>setForm({...form, phone:e.target.value})} /></div>
                <div><label className="text-[11px] uppercase tracking-[0.22em] text-brand-charcoal/55">Subject</label><input data-testid="ct-subject" className="pp-input" value={form.subject} onChange={(e)=>setForm({...form, subject:e.target.value})} /></div>
              </div>
              <div><label className="text-[11px] uppercase tracking-[0.22em] text-brand-charcoal/55">Message</label><textarea data-testid="ct-msg" rows="5" className="pp-input" required value={form.message} onChange={(e)=>setForm({...form, message:e.target.value})} /></div>
              <button data-testid="ct-submit" className="btn-pill btn-dark">Send Message</button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
